import { useState } from 'react'
import { isMobileDevice } from './../tools/platform'
import { useDimensions } from 'react-native-responsive-ui/src'

export const usePlatforms = () => {
  const { width } = useDimensions()
  const isTablet = width >= 768
  const isDesktop = width >= 1024
  const [isMobile] = useState(isMobileDevice())

  return {
    isTablet,
    isDesktop,
    isMobile
  }
}
